export enum CallToActionRoutes {
  HOME = 'HOME',
  MEDICAL = 'MEDICAL',
  GUIDES = 'GUIDES',
  GUIDES_DETAILS = 'GUIDES_DETAILS',
  BENEFITS = 'BENEFITS',
  BENEFITS_DETAILS = 'BENEFITS_DETAILS',
  MORE = 'MORE',
}
